/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "kemarin",
        "-2": "kemarin dulu",
        "0": "hari ini",
        "1": "besok",
        "2": "lusa",
        "future": {
          "other": "dalam {0} hari"
        },
        "past": {
          "other": "{0} hari yang lalu"
        }
      },
      "day-narrow": {
        "-1": "kemarin",
        "-2": "selumbari",
        "0": "hari ini",
        "1": "besok",
        "2": "lusa",
        "future": {
          "other": "dalam {0} h"
        },
        "past": {
          "other": "{0} h lalu"
        }
      },
      "day-short": {
        "-1": "kemarin",
        "-2": "selumbari",
        "0": "hari ini",
        "1": "besok",
        "2": "lusa",
        "future": {
          "other": "dalam {0} h"
        },
        "past": {
          "other": "{0} h lalu"
        }
      },
      "hour": {
        "0": "jam ini",
        "future": {
          "other": "dalam {0} jam"
        },
        "past": {
          "other": "{0} jam yang lalu"
        }
      },
      "hour-narrow": {
        "0": "jam ini",
        "future": {
          "other": "dalam {0} jam"
        },
        "past": {
          "other": "{0} jam lalu"
        }
      },
      "hour-short": {
        "0": "jam ini",
        "future": {
          "other": "dalam {0} jam"
        },
        "past": {
          "other": "{0} jam lalu"
        }
      },
      "minute": {
        "0": "menit ini",
        "future": {
          "other": "dalam {0} menit"
        },
        "past": {
          "other": "{0} menit yang lalu"
        }
      },
      "minute-narrow": {
        "0": "mnt ini",
        "future": {
          "other": "dlm {0} mnt"
        },
        "past": {
          "other": "{0} mnt lalu"
        }
      },
      "minute-short": {
        "0": "mnt ini",
        "future": {
          "other": "dlm {0} mnt"
        },
        "past": {
          "other": "{0} mnt lalu"
        }
      },
      "month": {
        "-1": "bulan lalu",
        "0": "bulan ini",
        "1": "bulan depan",
        "future": {
          "other": "dalam {0} bulan"
        },
        "past": {
          "other": "{0} bulan yang lalu"
        }
      },
      "month-narrow": {
        "-1": "bln lalu",
        "0": "bln ini",
        "1": "bln berikutnya",
        "future": {
          "other": "dlm {0} bln"
        },
        "past": {
          "other": "{0} bln lalu"
        }
      },
      "month-short": {
        "-1": "bln lalu",
        "0": "bln ini",
        "1": "bln berikutnya",
        "future": {
          "other": "dlm {0} bln"
        },
        "past": {
          "other": "{0} bln lalu"
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "Kuartal lalu",
        "0": "kuartal ini",
        "1": "kuartal berikutnya",
        "future": {
          "other": "dalam {0} kuartal"
        },
        "past": {
          "other": "{0} kuartal yang lalu"
        }
      },
      "quarter-narrow": {
        "-1": "krtl lalu",
        "0": "krtl ini",
        "1": "krtl berikutnya",
        "future": {
          "other": "dlm {0} krtl."
        },
        "past": {
          "other": "{0} krtl. lalu"
        }
      },
      "quarter-short": {
        "-1": "krtl lalu",
        "0": "krtl ini",
        "1": "krtl berikutnya",
        "future": {
          "other": "dlm {0} krtl."
        },
        "past": {
          "other": "{0} krtl. lalu"
        }
      },
      "second": {
        "0": "sekarang",
        "future": {
          "other": "dalam {0} detik"
        },
        "past": {
          "other": "{0} detik yang lalu"
        }
      },
      "second-narrow": {
        "0": "sekarang",
        "future": {
          "other": "dlm {0} dtk"
        },
        "past": {
          "other": "{0} dtk lalu"
        }
      },
      "second-short": {
        "0": "sekarang",
        "future": {
          "other": "dlm {0} dtk"
        },
        "past": {
          "other": "{0} dtk lalu"
        }
      },
      "week": {
        "-1": "minggu lalu",
        "0": "minggu ini",
        "1": "minggu depan",
        "future": {
          "other": "dalam {0} minggu"
        },
        "past": {
          "other": "{0} minggu yang lalu"
        }
      },
      "week-narrow": {
        "-1": "mgg lalu",
        "0": "mgg ini",
        "1": "mgg depan",
        "future": {
          "other": "dlm {0} mgg"
        },
        "past": {
          "other": "{0} mgg lalu"
        }
      },
      "week-short": {
        "-1": "mgg lalu",
        "0": "mgg ini",
        "1": "mgg depan",
        "future": {
          "other": "dlm {0} mgg"
        },
        "past": {
          "other": "{0} mgg lalu"
        }
      },
      "year": {
        "-1": "tahun lalu",
        "0": "tahun ini",
        "1": "tahun depan",
        "future": {
          "other": "dalam {0} tahun"
        },
        "past": {
          "other": "{0} tahun yang lalu"
        }
      },
      "year-narrow": {
        "-1": "thn lalu",
        "0": "thn ini",
        "1": "thn depan",
        "future": {
          "other": "dlm {0} thn"
        },
        "past": {
          "other": "{0} thn lalu"
        }
      },
      "year-short": {
        "-1": "thn lalu",
        "0": "thn ini",
        "1": "thn depan",
        "future": {
          "other": "dlm {0} thn"
        },
        "past": {
          "other": "{0} thn lalu"
        }
      }
    },
    "locale": "id"
  });
}